'use strict';

module.exports = require('./lib/ReactDOM');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dom/index.js
 ** module id = ./node_modules/react-dom/index.js
 ** module chunks = 1
 **/